import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.scss';
import { themr } from 'react-css-themr';

const BreakLine = ({ theme }) => (<div className={theme.breakLine} />);

BreakLine.propTypes = {
  theme: PropTypes.shape({}),
};

export default themr('BreakLine', styles)(BreakLine);



// WEBPACK FOOTER //
// ./client/app/shared/components/BreakLine/index.jsx